export const Step = {
  VerificationLookupPillow: 'VerificationLookupPillow',
  VerificationDocumentsList: 'VerificationDocumentsList',
  VerificationDocumentUpload: 'VerificationDocumentUpload',
  Exit: 'Exit',
  ExitToDashboard: 'ExitToDashboard',
};
